import { render, staticRenderFns } from "./IncreaseCountry.vue?vue&type=template&id=5c705a7b"
import script from "./IncreaseCountry.vue?vue&type=script&lang=js"
export * from "./IncreaseCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports